import { render, staticRenderFns } from "./WxOpenTip.vue?vue&type=template&id=706f4d02&scoped=true"
import script from "./WxOpenTip.vue?vue&type=script&lang=js"
export * from "./WxOpenTip.vue?vue&type=script&lang=js"
import style0 from "./WxOpenTip.vue?vue&type=style&index=0&id=706f4d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f4d02",
  null
  
)

export default component.exports